import { createAction, props } from "@ngrx/store";
import { Cotizacion } from "../../Models/cotizacion";
import { CrearCotizacion } from "../../Models/crearCotizacion";

export const loadCrearCotizacion = createAction('loadCrearCotizacion', props<{ data: CrearCotizacion }>());

export const updateCotizacionResponse = createAction('updateCotizacionResponse', props<{ CotizacionResp: Cotizacion }>());

export const updateCrearCotizacion = createAction('updateCrearCotizacion', props<{ upCrearCotizacion: CrearCotizacion }>());